<template>
  <div
    class="services-test-area bg-mg ptb-100 position-relative overflow-hidden"
    :style="{ backgroundImage: 'url(' + bgImage + ')' }"
  >
    <div class="container mw-1356">
      <div
        class="services-test-content"
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-delay="100"
      >
        <span class="top-title">تجربة الخدمة</span>
        <h2 class="text-white">
          ابدأ الآن.. لا تتردد في اختبار جودة سيرفراتنا بنفسك
        </h2>
        <p class="text-silver">
          احصل على حساب تجريبي وصولاً كاملاً لجميع القنوات المباشرة، الأفلام، والمسلسلات بدون أي قيود.
        </p>
        <div class="d-flex align-items-center amount">
          <div class="flex-shrink-0">
            <i class="flaticon-tv"></i>
          </div>
          <div class="flex-grow-1 ms-3">
            <h2>10.00 €<sub>/ تجربة شهر</sub></h2>
            <span>تجربة لمدة شهر كامل - رضاك مضمون أو استرداد أموالك.</span>
          </div>
        </div>
        <div class="d-flex gap-2 flex-wrap">
          <a href="https://wa.me/447429916178?text=%D9%85%D8%B1%D8%AD%D8%A8%D8%A7%D9%8B%D8%8C%20%D8%A3%D8%B1%D9%8A%D8%AF%20%D8%B7%D9%84%D8%A8%20%D8%A7%D8%B4%D8%AA%D8%B1%D8%A7%D9%83%20%D8%AA%D8%AC%D8%B1%D9%8A%D8%A8%D9%8A%20%D9%84%D9%85%D8%AF%D8%A9%20%D8%B4%D9%87%D8%B1" target="_blank" class="btn bg-grey-teal">
            <span class="border-style">اطلب تجربة فورية الآن</span>
          </a>
          <a href="https://wa.me/447429916178?text=%D9%85%D8%B1%D8%AD%D8%A8%D8%A7%D9%8B%D8%8C%20%D9%84%D8%AF%D9%8A%20%D8%A7%D8%B3%D8%AA%D9%81%D8%B3%D8%A7%D8%B1%20%D9%82%D8%A8%D9%84%20%D8%A7%D9%84%D8%A7%D8%B4%D8%AA%D8%B1%D8%A7%D9%83" target="_blank" class="btn bg-transparent">
            <span class="border-style">
              <span>تواصل معنا</span> لأي استفسار أو سؤال
            </span>
          </a>
        </div>
      </div>
    </div>

    <img src="@/assets/images/shape-9.png" class="shape shape-9" alt="shape" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "TestOurService",
  setup() {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const bgImage = require("@/assets/images/services-test-bg-2.jpg");

    return {
      bgImage,
    };
  },
});
</script>